import { CommonModule } from "@angular/common";
import { Component, DestroyRef, inject, OnInit } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import {
  AbstractControl, ControlContainer,
  FormGroup, FormGroupDirective,
  ReactiveFormsModule
} from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { debounceTime, distinctUntilChanged } from "rxjs";
import { ConsumerProfileService } from "../../../dashboard/profile/services/profile.service";
import { RIDInputDirective } from "../../../shared/directives/rid-input.directive";
import { TouchedErrorStateMatcher } from "../../../shared/other/touched-form-error-state-matcher";


@Component({
  selector: 'app-consumer-details',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    RIDInputDirective
],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
  templateUrl: './consumer-details.component.html',
  styleUrl: './consumer-details.component.scss',
})

export class ConsumerDetailsComponent implements OnInit {
  private postTripRequestFormDir = inject(FormGroupDirective);
  private destroyRef = inject(DestroyRef);
  private profileService = inject(ConsumerProfileService)
  tripRequest!: FormGroup;
  matcher = new TouchedErrorStateMatcher();
  previousRID = '';

    
  ngOnInit(): void {
    this.tripRequest = this.postTripRequestFormDir.form.get("tripRequest") as FormGroup;

    this.tripRequest.get('recipientId')?.valueChanges.pipe(
        debounceTime(300), 
        distinctUntilChanged(), 
        takeUntilDestroyed(this.destroyRef))
      .subscribe((value) => {
        //this.tripRequest.get('recipientId')?.setErrors(null);
        const length = value ? value.length : 0;
        if (length === 10 && value.toString() !== this.previousRID) {
          this.previousRID = value.toString();
          this.profileService.getConsumerDemographicInfo(Number(value)).subscribe((data) => {
            if(data) {
              this.tripRequest.get('firstName')?.setValue(data.firstName);
              this.tripRequest.get('lastName')?.setValue(data.lastName);
              this.tripRequest.get('middleInitial')?.setValue(data.middleInitial);
            }
            else {
              this.tripRequest.get('firstName')?.setValue('');
              this.tripRequest.get('lastName')?.setValue('');
              this.tripRequest.get('middleInitial')?.setValue('');

              this.tripRequest.get('recipientId')?.setErrors({ 'invalid-rid': true });
              this.tripRequest.get('recipientId')?.markAsTouched();
            }
          });
      }
    });
  }

  
  hasError(controlName: string, errorName: string): boolean {
    const control: AbstractControl | null = this.tripRequest.get(`${controlName}`);
    return !!control && control.hasError(errorName) && (control.dirty || control.touched);
  }

}